<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import Multiselect from 'vue-multiselect';
import Swal from "sweetalert2";
import DatePicker from "vue2-datepicker";
import moment from "moment";
import pdf from 'vue-pdf'
/**
 * Starter component
 */
export default {
    components: { Layout, PageHeader, Multiselect, DatePicker, pdf },
    data() {
        return {
            title: "Agregar Gasto Asociado",
            items: [
                {
                text: "Reembolsos",
                href: "/"
                },
                {
                text: "Agregar Gasto Asociado",
                active: true
                }
            ],
            eventos:[],
            colegios:[],
            cajasChicas: [],
            tipos:['Transporte local/Nacional','Alimentos/bebidas reuniones','Peaje y estacionamiento','Gasolina','Materiales de oficina','Hospedaje','Pasajes bus/tren/avion'],
            gasto:{
                evento:'',
                tipo:'',
                caja_chica_id:'',
                monto:'$0',
                imagen:[],
                fecha:'',
                colegio:''
            },
            file: null,
            imagenminiatura:'',
            colegiosFiltrados:[],
            eventoscolegiosFiltrados:[],
            eventosFiltrados:[],
            archivoPreview: '',
            tipoArchivo: '',
            isSavingGasto: false,
            documentoComprimido: false,
            documentoPesoOriginal: 0,
            documentoPesoFinal: 0
        };
    },
    computed: {
        imagen(){
        return this.imagenminiatura;
        },
        nombreDocumentoSeleccionado() {
            if (!this.gasto || !this.gasto.imagen) {
                return '';
            }

            return this.gasto.imagen.name || '';
        },
        resumenDocumento() {
            if (!this.documentoPesoFinal) {
                return '';
            }

            if (this.documentoComprimido && this.documentoPesoOriginal > this.documentoPesoFinal) {
                return `Imagen optimizada antes de subir: ${this.formatFileSize(this.documentoPesoOriginal)} -> ${this.formatFileSize(this.documentoPesoFinal)}`;
            }

            return `Tamaño del archivo: ${this.formatFileSize(this.documentoPesoFinal)}`;
        },
        busqueda(){
            if (this.gasto.fecha=='') {
                return true;
            }else{
                return false;
            }
        },
        bus_even(){
            if (this.gasto.colegio=='') {
                return true;
            }else{
                return false;
            }
        },
        cajasChicasDisponibles() {
            return [
                { value: '', text: 'Sin caja chica' },
                ...this.cajasChicas.map((caja) => ({
                    value: caja.id,
                    text: caja.sede ? `${caja.nombre} (${caja.sede})` : caja.nombre,
                })),
            ];
        }
    },
    methods:{
        labelEvento(evento) {
            return `${evento.codigo} - ${evento.nombre_difusion}`;
        },
        labelColegio(colegio) {
            return `${colegio.rbd} - ${colegio.nombre}`;
        },
        format_Valor(){
            this.gasto.monto=this.format_Valor_variable(this.gasto.monto);
        },
        format_Valor_variable(val){
            return val? parseInt(val.toString().replace(/[^0-9]/g, ''), 10)? parseInt(val.toString().replace(/[^0-9]/g, ''), 10).toLocaleString("es-CL", { style: "currency", currency: "CLP" }): '$0': '$0';
        },
        async obtenerImagen(e){
            let file = e.target.files[0];
            if (!file) return;

            this.documentoPesoOriginal = file.size || 0;
            this.documentoPesoFinal = file.size || 0;
            this.documentoComprimido = false;

            if (file.type.includes("image")) {
                file = await this.optimizarImagen(file);
                this.documentoPesoFinal = file.size || 0;
                this.documentoComprimido = this.documentoPesoFinal < this.documentoPesoOriginal;
            }

            this.gasto.imagen = file;
            this.cargarImagen(file);
        },
        resetFormulario() {
            this.gasto.fecha='';
            this.gasto.colegio='';
            this.gasto.evento='';
            this.gasto.tipo='';
            this.gasto.caja_chica_id='';
            this.gasto.monto='$0';
            this.gasto.imagen=[];
            this.imagenminiatura='';
            this.tipoArchivo='';
            this.colegiosFiltrados=[];
            this.eventoscolegiosFiltrados=[];
            this.eventosFiltrados=[];
            this.documentoComprimido = false;
            this.documentoPesoOriginal = 0;
            this.documentoPesoFinal = 0;

            if (this.$refs.inputComprobante) {
                this.$refs.inputComprobante.value = '';
            }
        },
        abrirSelectorDocumento() {
            if (this.$refs.inputComprobante) {
                this.$refs.inputComprobante.click();
            }
        },
        limpiarDocumento() {
            this.gasto.imagen = [];
            this.imagenminiatura = '';
            this.tipoArchivo = '';
            this.documentoComprimido = false;
            this.documentoPesoOriginal = 0;
            this.documentoPesoFinal = 0;

            if (this.$refs.inputComprobante) {
                this.$refs.inputComprobante.value = '';
            }
        },
        formatFileSize(bytes) {
            if (!bytes) {
                return '0 KB';
            }

            if (bytes >= 1024 * 1024) {
                return `${(bytes / (1024 * 1024)).toFixed(2)} MB`;
            }

            return `${Math.max(1, Math.round(bytes / 1024))} KB`;
        },
        loadImageFromFile(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();

                reader.onload = () => {
                    const image = new Image();
                    image.onload = () => resolve(image);
                    image.onerror = () => reject(new Error('No se pudo procesar la imagen seleccionada.'));
                    image.src = reader.result;
                };

                reader.onerror = () => reject(new Error('No se pudo leer la imagen seleccionada.'));
                reader.readAsDataURL(file);
            });
        },
        canvasToBlob(canvas, type, quality) {
            return new Promise((resolve, reject) => {
                canvas.toBlob((blob) => {
                    if (!blob) {
                        reject(new Error('No se pudo optimizar la imagen.'));
                        return;
                    }

                    resolve(blob);
                }, type, quality);
            });
        },
        buildCompressedFileName(file, extension) {
            const baseName = (file.name || 'comprobante').replace(/\.[^.]+$/, '');
            return `${baseName}.${extension}`;
        },
        async optimizarImagen(file) {
            try {
                const image = await this.loadImageFromFile(file);
                const maxDimension = 1800;
                const scale = Math.min(1, maxDimension / Math.max(image.width, image.height));
                const width = Math.max(1, Math.round(image.width * scale));
                const height = Math.max(1, Math.round(image.height * scale));
                const canvas = document.createElement('canvas');
                const context = canvas.getContext('2d');

                canvas.width = width;
                canvas.height = height;

                context.fillStyle = '#ffffff';
                context.fillRect(0, 0, width, height);
                context.drawImage(image, 0, 0, width, height);

                const blob = await this.canvasToBlob(canvas, 'image/jpeg', 0.88);
                const optimizedFile = new File(
                    [blob],
                    this.buildCompressedFileName(file, 'jpg'),
                    {
                        type: 'image/jpeg',
                        lastModified: Date.now(),
                    }
                );

                return optimizedFile.size < file.size ? optimizedFile : file;
            } catch (error) {
                console.error('No se pudo optimizar la imagen, se enviará el archivo original.', error);
                return file;
            }
        },
        cargarImagen(file){
            let reader = new FileReader();
            // Verificar el tipo de archivo
            if (file.type.includes("image")) {
                this.tipoArchivo = "imagen";
            } else if (file.type.includes("pdf")) {
                this.tipoArchivo = "pdf";
            } else {
                this.tipoArchivo = "";
                return;
            }
            reader.onload = (e) => {
                this.imagenminiatura = e.target.result;
            };
            reader.readAsDataURL(file);
        },
        async guardar(){
            let formData = new FormData();
            formData.append('evento_id', this.gasto.evento.id);
            formData.append('fecha', this.gasto.fecha);
            formData.append('tipo', this.gasto.tipo);
            formData.append('caja_chica_id', this.gasto.caja_chica_id || '');
            formData.append('monto', this.gasto.monto);
            formData.append('imagen', this.gasto.imagen);
            formData.append('coordinador_id', this.gasto.evento.coordinador_evento);
            this.isSavingGasto = true;

            try {
                const res = await axios.post('/api/agregar_gastos',formData);
                if(res.data.estado){
                    this.resetFormulario();
                    this.msg('success','Gasto agregado correctamente');
                }else{
                    this.msg('error', res.data.mensaje || 'Gasto no agregado');
                }
            } catch (error) {
                const mensaje = error?.response?.data?.mensaje
                    || error?.response?.data?.errors
                    || 'No se pudo guardar el gasto. Intente nuevamente.';

                const detalle = typeof mensaje === 'string'
                    ? mensaje
                    : Object.values(mensaje).flat().join(' ');

                this.msg('error', 'Error al guardar gasto', detalle);
            } finally {
                this.isSavingGasto = false;
            }
        },
        validaciones(){
            if(this.gasto.fecha=='' || this.gasto.fecha==null){
                this.msg('error','Falta campo por completar','Fecha');
                return
            }
            if(this.gasto.colegio=='' || this.gasto.colegio==null){
                this.msg('error','Falta campo por completar','Colegio');
                return
            }
            if(this.gasto.evento=='' || this.gasto.evento==null){
                this.msg('error','Falta campo por completar','Evento');
                return
            }
            if(this.gasto.tipo=='' || this.gasto.tipo==null){
                this.msg('error','Falta campo por completar','Tipo');
                return
            }
            if(this.gasto.monto=='' || this.gasto.monto==null){
                this.msg('error','Falta campo por completar','Monto');
                return
            }
            if(!this.gasto.imagen || !this.gasto.imagen.name){
                this.msg('error','Falta campo por completar','Documento');
                return
            }
            this.guardar();
        },
        msg(tipo,titulo,frase){
            Swal.fire({
                //position: "top-end",
                icon: tipo,
                title: titulo,
                text: frase,
                showConfirmButton: false,
                timer: 5000
            });
        },
        filtro_colegios() {
            if (!this.gasto.fecha) return;
            this.gasto.colegio = '';
            this.gasto.evento = '';
            this.eventosFiltrados = [];
            // Filtrar eventos por la fecha seleccionada
            this.eventoscolegiosFiltrados = this.eventos.filter(
                (evento) => moment(evento.fecha_inicio).format('YYYY-MM-DD') === this.gasto.fecha
            );
            // Extraer RBD únicos y normalizarlos numéricamente cuando sea posible
            const rbdUnicos = [...new Set(this.eventoscolegiosFiltrados.map(evento => {
                const n = Number(evento.rbd_colegio);
                return isNaN(n) ? String(evento.rbd_colegio).trim() : n;
            }))];
            // Filtrar colegios con los RBD obtenidos (comparación numérica preferente)
            this.colegiosFiltrados = this.colegios.filter(colegio => {
                const rbdNum = Number(colegio.rbd);
                if (!isNaN(rbdNum)) {
                    return rbdUnicos.includes(rbdNum);
                }
                return rbdUnicos.includes(String(colegio.rbd).trim());
            });
        },
        filtro_eventos(){
            this.gasto.evento = '';
            this.eventosFiltrados = this.eventoscolegiosFiltrados.filter(
                (evento) => evento.rbd_colegio == this.gasto.colegio.rbd
            );
        },
        disabledBeforeToday(date) {
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            return date > today ;
        },
    },
    created(){
        axios.get('/api/get_eventos').then(res=>{
            //this.eventos=res.data.eventos
            this.eventos = res.data.eventos.filter(evento => new Date(evento.fecha_inicio) <= new Date());
        });
        axios.get('/api/cajas_chicas').then((response) => {
            if (response.data && response.data.estado) {
                this.cajasChicas = response.data.cajas || [];
            }
        });
        axios.get(`/api/get_colegios`).then(response => {
            if(response.data.estado){
                this.colegios = response.data.colegios;
            }
        });
    }
};
</script>
<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <loading-message
            v-if="isSavingGasto"
            title="Guardando gasto"
            subtitle="Estamos cargando el comprobante y esperando la respuesta del servidor. No cierres esta ventana."
        />
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="row mt-4">
                            <div class="col-md-6">
                                <div class="form-group row">
                                    <div class="col-md-6">
                                        <label for="pais"> Fecha:</label>
                                    </div>
                                    <div class="col-md-12">
                                        <date-picker v-model="gasto.fecha" value-type="YYYY-MM-DD" format="DD-MM-YYYY" :first-day-of-week="2" lang="es" :disabled-date="disabledBeforeToday" @change="filtro_colegios"></date-picker>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group row">
                                    <div class="col-md-6">
                                        <label for="pais"> Colegio:</label>
                                    </div>
                                    <div class="col-md-12">
                                        <multiselect
                                            v-model="gasto.colegio"
                                            :options="colegiosFiltrados"
                                            placeholder="Seleccionar colegio"
                                            selectLabel="Presiona para seleccionar"
                                            selectedLabel="Seleccionado"
                                            deselectLabel="Presiona para remover"
                                            :custom-label="labelColegio"
                                            :disabled="busqueda"
                                            @select="filtro_eventos"
                                            >
                                            <template v-slot:noOptions>
                                                <p>No hay opciones</p>
                                            </template>
                                            <template v-slot:noResult>
                                                <p>No se encuentra coincidencia</p>
                                            </template>
                                        </multiselect>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group row">
                                    <div class="col-md-6">
                                        <label for="pais"> Evento:</label>
                                    </div>
                                    <div class="col-md-12">
                                        <multiselect
                                            v-model="gasto.evento"
                                            :options="eventosFiltrados"
                                            placeholder="Seleccionar evento"
                                            selectLabel="Presiona para seleccionar"
                                            selectedLabel="Seleccionado"
                                            deselectLabel="Presiona para remover"
                                            :custom-label="labelEvento"
                                            :disabled="bus_even"
                                            >
                                            <template v-slot:noOptions>
                                                <p>No hay opciones</p>
                                            </template>
                                            <template v-slot:noResult>
                                                <p>No se encuentra coincidencia</p>
                                            </template>
                                        </multiselect>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group row">
                                    <div class="col-md-6">
                                        <label for="pais"> Tipo de gasto:</label>
                                    </div>
                                    <div class="col-md-12">
                                        <multiselect
                                            v-model="gasto.tipo"
                                            :options="tipos"
                                            placeholder="Seleccionar tipo"
                                            selectLabel="Presiona para seleccionar"
                                            selectedLabel="Seleccionado"
                                            deselectLabel="Presiona para remover"
                                            >
                                            <template v-slot:noOptions>
                                                <p>No hay opciones</p>
                                            </template>
                                            <template v-slot:noResult>
                                                <p>No se encuentra coincidencia</p>
                                            </template>
                                        </multiselect>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group row">
                                    <div class="col-md-6">
                                        <label for="pais"> Monto del Gasto:</label>
                                    </div>
                                    <div class="col-md-12">
                                        <b-form-input v-model="gasto.monto" class="border-primary" @input="format_Valor"></b-form-input>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group row">
                                    <div class="col-md-6">
                                        <label for="caja-chica"> Caja chica:</label>
                                    </div>
                                    <div class="col-md-12">
                                        <b-form-select id="caja-chica" v-model="gasto.caja_chica_id" :options="cajasChicasDisponibles"></b-form-select>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group row">
                                    <div class="col-md-6">
                                        <label for="pais"> Documento Asociado:</label>
                                    </div>
                                    <div class="col-md-12">
                                        <input
                                            ref="inputComprobante"
                                            type="file"
                                            class="d-none"
                                            accept="image/png, image/jpeg, image/jpg, application/pdf"
                                            @change="obtenerImagen"
                                        >
                                        <div class="carga-documento-gasto">
                                            <div class="carga-documento-gasto__top">
                                                <div>
                                                    <strong>{{ nombreDocumentoSeleccionado || 'Ningún archivo seleccionado' }}</strong>
                                                    <div class="text-muted small">Formatos permitidos: JPG, PNG y PDF. Tamaño máximo: 2 MB.</div>
                                                    <div v-if="resumenDocumento" class="text-muted small mt-1">{{ resumenDocumento }}</div>
                                                </div>
                                                <div class="carga-documento-gasto__actions">
                                                    <b-button variant="outline-primary" @click="abrirSelectorDocumento" :disabled="isSavingGasto">
                                                        {{ nombreDocumentoSeleccionado ? 'Cambiar archivo' : 'Elegir archivo' }}
                                                    </b-button>
                                                    <b-button v-if="nombreDocumentoSeleccionado" variant="outline-secondary" @click="limpiarDocumento" :disabled="isSavingGasto">
                                                        Quitar
                                                    </b-button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12 text-right">
                                <b-button variant="primary" @click="validaciones" :disabled="isSavingGasto">
                                    {{ isSavingGasto ? 'Guardando...' : 'Guardar' }}
                                </b-button>
                            </div>
                            <div class="offset-md-1 col-md-10 text-center mt-3" v-if="tipoArchivo">
                                <div class="preview-documento-gasto card border-light shadow-sm">
                                    <div class="card-body">
                                        <h5 class="mb-3">Vista previa del comprobante</h5>
                                <!-- Mostrar imagen si el archivo es imagen -->
                                <figure v-if="tipoArchivo === 'imagen'" class="mb-0">
                                    <img :src="imagenminiatura" class="preview-documento-gasto__imagen" alt="Vista previa del comprobante">
                                </figure>
                                <!-- Mostrar PDF si el archivo es PDF -->
                                <div v-if="tipoArchivo === 'pdf'">
                                    <pdf :src="imagenminiatura"></pdf>
                                </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Layout>
</template>

<style>
.carga-documento-gasto {
    border: 1px dashed #d8c1aa;
    border-radius: 0.5rem;
    padding: 1rem;
    background: #fcfaf7;
}

.carga-documento-gasto__top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
}

.carga-documento-gasto__actions {
    display: flex;
    gap: 0.5rem;
    flex-wrap: wrap;
}

.preview-documento-gasto {
    background: #fff;
}

.preview-documento-gasto__imagen {
    max-width: 100%;
    max-height: 420px;
    object-fit: contain;
}

@media (max-width: 768px) {
    .carga-documento-gasto__top {
        flex-direction: column;
        align-items: stretch;
    }
}
</style>
